import { Model, Attr } from "spraypaint";
import { ApplicationRecord } from "./ApplicationRecord";

@Model()
export class InventoryRoom extends ApplicationRecord {
  static jsonapiType = "inventory_rooms";

  @Attr() roomName!: string;
}
